import { API_URL, API_VERSION } from '@/constants'
import React from 'react'

import { altchaStateActions } from '@/state/altcha/actions'

import './styles.scss'

export function AltchaComponent({
  id,
}: {
  id: string
  style?: React.CSSProperties
}): JSX.Element {
  React.useEffect(() => {
    document
      ?.querySelector(`#${id}`)
      ?.addEventListener('statechange', (ev: any) => {
        const payload = ev?.detail?.payload
        const state = ev?.detail?.state

        if (state === 'verified') {
          altchaStateActions.setAltcha(payload)
        }
      })
  }, [])

  return (
    <altcha-widget
      id={id}
      spamfilter
      strings={JSON.stringify({
        error: 'Error de verificación. Inténtalo de nuevo más tarde.',
        footer: '',
        label: 'No soy un robot',
        verified: 'Verificado',
        verifying: 'Verificando...',
        waitAlert: 'Verificando... por favor espere.',
      })}
      challengeurl={`${API_URL}/api/${API_VERSION}/altcha/generate`}
      hidelogo
    />
  )
}
